export const MetricCardsName = {
  LOAN_AMOUNT: 'Loan Amount',
  LOAN_TYPE: 'Loan Type',
  LTV_CLTV_HLTV: 'LTV/CLTV/HLTV',
  MONTHLY_PAYMENT: 'Monthly Payment',
  HOUSING_EXPENSE: 'Housing Expense (DTI)',
};

// The preview fields each card is highlighted on, per source DTO; its author dots read the same fields' changes.
export const LOAN_AMOUNT_CHART_LEGEND_FIELDS = ['TotalLoanAmount', 'HelocDrawAmount'];

export const LOAN_TYPE_PROGRAM_FIELDS = ['LoanType'];

export const LTV_CHART_LEGEND_FIELDS = ['Ltv', 'Cltv', 'Hltv'];

export const MONTHLY_PAYMENT_SUBJECT_PROPERTY_FIELDS = [
  'MonthlyPayment',
  'DrawBasedMonthlyPayment',
  'QualifyingMonthlyPayment',
  'PrincipalAndInterest',
  'InterestOnlyPayment',
];

export const MONTHLY_PAYMENT_PROGRAM_FIELDS = ['InterestOnlyPayment'];

export const MONTHLY_PAYMENT_CHART_LEGEND_FIELDS = ['HelocDrawAmount'];
